angular.module('moebiusProadapt').controller('ctrlAdminIndex',
    ['$scope', '$http', '$location', 'adminResolver', '$uibModal', 'promiseTracker', function($scope, $http, $location, adminResolver, $uibModal, promiseTracker){

        /*console.log('ctrlAdminIndex bootstrap');
        console.log(adminResolver);*/

        $scope.centres          = adminResolver.centres;
        $scope.usersArcNoCentre = adminResolver.usersArcNoCentre;
        $scope.selectedCentre = {};
        $scope.etudes_instances = adminResolver.etudes_instances;

        // $scope.goToDetail = function(cabinet){
        //     $location.path('admin/detail/' + cabinet.id);
        // }

        $scope.tracker      = promiseTracker('tracker');

        $scope.openModalCentre = function (centre) {
            $scope.selectedCentre = {};
            var scopeModal = $scope.$new();

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/admin/modal-add-centre.html',
                controller: 'ctrlAdminAddCentre',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    centre: angular.copy(centre)
                }
            });

            var promise = modalInstance.result;
            var promiseFullClosed = modalInstance.closed;

            $scope.tracker.addPromise(promise);

            promise.then(function (item) {
                // si action cancelled
                if (!item) {
                    return;
                }

                // une fois la réponse reçue, ajout ou édition de la liste
                let indexCentre = _.findIndex($scope.centres, { id: item.id });
                if (indexCentre !== -1) {
                    let editedCentre = angular.extend({}, $scope.centres[indexCentre], item);
                    $scope.centres.splice(indexCentre, 1, editedCentre);
                } else {
                    item.users = [];
                    $scope.centres.push(item);
                }

            });
        };

        $scope.openModalUser = function (user) {
            //le role doit être au format chaine de caractères pour remplir le menu déroulant
            if(user.role) {
                user.role = user.role+"";
            }

            var current_centre_id = user.centre_id;

            var scopeModal = $scope.$new();

            //Create modal instance
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/admin/modal-add-user.html',
                controller: 'ctrlAdminAddUser',
                windowClass: 'md-dialog',
                scope: scopeModal,
                backdrop: 'static',
                resolve: {
                    user: angular.copy(user)
                }
            });

            var promise = modalInstance.result;
            var promiseFullClosed = modalInstance.closed;

            $scope.tracker.addPromise(promise);

            promise.then(function (item) {
                // si action cancelled
                if (!item) {
                    return;
                }

                if(item.centre_id != null){
                    // une fois la réponse reçue, ajout ou édition de la liste
                    let indexCentre = _.findIndex($scope.centres, { id: item.centre_id });
                    let indexUser = _.findIndex($scope.centres[indexCentre].users, { id: item.id });
                    if (indexUser !== -1) {
                        $scope.centres[indexCentre].users.splice(indexUser, 1, item);
                    } else {
                        $scope.centres[indexCentre].users.push(item);
                    }
                }else{
                    // check if user is already in usersArcNoCentre array
                    let isUserExists = _.find($scope.usersArcNoCentre, { id: item.id }) != null;
                    if(!isUserExists){
                        $scope.usersArcNoCentre.push(item);
                    }
                }

                //si était auparavant dans un autre centre, on l'en retire
                if(item.centre_id !== current_centre_id) {
                    if(current_centre_id != null){
                        let indexC = _.findIndex($scope.centres, { id: current_centre_id });
                        let indexU = _.findIndex($scope.centres[indexC].users, { id: item.id });
                        $scope.centres[indexC].users.splice(indexU, 1);
                    }else{
                        let indexU = _.findIndex($scope.usersArcNoCentre, { id: item.id });
                        $scope.usersArcNoCentre.splice(indexU, 1);
                    }
                }
            });
        };

        $scope.selectCentre  = function(centreId) {
            if(centreId == null){ // ARC users might not have centres
                $scope.selectedCentre = {
                    id: -1,
                    name: "Users Arc sans centres",
                    users: $scope.usersArcNoCentre
                }
            }else{
                let indexCentre = _.findIndex($scope.centres, { id: centreId });
                $scope.selectedCentre = $scope.centres[indexCentre];
            }
        };

        $scope.toggleCentreEtude = function(centreId, etiId) {
            var url = 'centre-etude';

            // -- il faut travailler sur l'arbre
            var centre = _.find($scope.centres, {id: centreId});
            var centreEtude = _.find(centre.centres_etudes, {etude_instance_id: etiId});
            if (centreEtude) {
                url += '/'+centreEtude.id;
                $http.delete(url).then(function() {
                    _.remove(centre.centres_etudes, {etude_instance_id: etiId});
                })
            } else {
                $http.post(url, {etude_instance_id: etiId, centre_id: centre.id, editOrSave:'SAVE'}).then(function(response) {
                    var centreEtude = response.data;
                    centre.centres_etudes.push(centreEtude);
                });
            }

        };
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/admin/adminIndex.js